import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpResponse, HttpEventType } from "@angular/common/http";
import { Router } from "@angular/router";
import { isDevMode } from '@angular/core';
import { Injectable } from "@angular/core";
import { tap, finalize, map } from "rxjs/operators";
import { Observable } from "rxjs";
import { LocalStorageService } from '../local-storage/local-storage.service';
import { ShellFacadeService } from '../shell/shell-facade.service';
import { LoaderService } from '../loader/loader.service';
import { environment } from "src/environments/environment";

@Injectable()

export class TokenInterceptor implements HttpInterceptor {
  constructor(
    private shellService: ShellFacadeService,
    private storageService: LocalStorageService,
    private loaderService: LoaderService,
    private router: Router,
  ) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    this.loaderService.show();

    if (this.storageService.loggedInUser) {
      req = req.clone({
        setHeaders: {
          Authorization: this.storageService.accessToken
        }
      });
    } else {
      req = req.clone();
    }

    return next.handle(req).pipe(
      
      tap(
        (event) => {},
        error => {
          if (error.status == 401 && this.storageService.loggedInUser) {
            this.router.navigate(["/"]);
            this.storageService.logoutUser();

            if (isDevMode()) {
              this.shellService.addUserRefreshToken(this.storageService.refreshToken).subscribe(
                success => {
                  this.storageService.accessToken = success.access;
                  this.storageService.refreshToken = success.refresh;
                  window.location.reload();
                },
                error => {
                  this.router.navigate(['/']);
                  this.storageService.logoutUser();
                }
              );
            }
          }
          // return error
        }
      ),
      finalize(() => this.loaderService.hide())
    );
  }

  updateHeader(req) {
    req = req.clone({
      setHeaders: {
        Authorization: this.storageService.accessToken
      }
    });
    return req;
  }
}
